module.exports = __webpack_public_path__ + "static/media/08yokohama.665c796a.png";